import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = {
  key: 0,
  class: "px column flex-center text-center",
  style: {"height":"100vh"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "v-spacer-lg" }, " Searching our therapist network to find the best match... ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_animation = _resolveComponent("loading-animation")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.globalLoading)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_loading_animation, { class: "v-spacer-lg" })
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_router_view, null, null, 512), [
      [_vShow, !_ctx.globalLoading]
    ])
  ]))
}